import React from 'react';
import { useIntl } from 'umi';
import MultipleSelector, { MulSelectorProps, SelectOptionWithGroup } from './MultipleSelector';

import type { IBaseProps } from '@/pages/intelligence/types/common';

import './index.scss';

const IPO_STATUS_MAPPING: {
  [key: string]: IIPOStatus;
} = {
  PUBLIC: 'Public',
  PRIVATE: 'Private',
  DELISTED: 'Delisted',
};

export const IPO_STATUSES: IIPOStatus[] = [
  IPO_STATUS_MAPPING.PUBLIC,
  IPO_STATUS_MAPPING.PRIVATE,
  IPO_STATUS_MAPPING.DELISTED,
];

export function getIPOStatusesNamesMapping(): {
  [key: string]: string;
} {
  const { formatMessage } = useIntl();
  return {
    [IPO_STATUS_MAPPING.PUBLIC]: formatMessage({ id: 'dbi_company_public' }),
    [IPO_STATUS_MAPPING.PRIVATE]: formatMessage({ id: 'dbi_company_private' }),
    [IPO_STATUS_MAPPING.DELISTED]: formatMessage({ id: 'dbi_company_delisted' }),
  };
}

export type IIPOStatus = 'Public' | 'Private' | 'Delisted' | (string & {});

interface IIPOStatusSelectorProps extends MulSelectorProps, IBaseProps {
  value: string[];
  onConfirm: (payload: string[]) => void;
}

export default function IPOStatusSelector(props: IIPOStatusSelectorProps) {
  const { formatMessage } = useIntl();

  const { value: valueOuter, onConfirm } = props;

  const value = Array.isArray(valueOuter) ? valueOuter : [];

  const ipoStatusesNamesMapping = getIPOStatusesNamesMapping();

  const ipoStatusesOptions: SelectOptionWithGroup[] = IPO_STATUSES.map((item) => ({
    text: ipoStatusesNamesMapping[item],
    value: item,
  }));

  return (
    <MultipleSelector
      hasAllCheck
      className="dbi-common-ipo-status-select"
      buttonName={formatMessage({ id: 'dbi_company_ipo_status' })}
      options={ipoStatusesOptions}
      value={value}
      onChange={onConfirm}
    />
  );
}
